// import React, { useEffect, useState } from "react";
// import { Colors } from "../../Constant/Color";
// import Navbar from "../../Components/Navbar";
// import { Card, Col, Row, Select } from "antd";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   PointElement,
//   LineElement
// } from "chart.js";
// import { Bar, Line } from "react-chartjs-2";
// import axios from "axios";
// import { Base_Uri } from "../../Constant/BaseUri";
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   PointElement,
//   LineElement
// );
// const Dashboard = () => {
//   const [chartData, setChartData] = useState({});
//   const [chartDataReturn, setChartDataReturn] = useState({});
//   const [chartDataExchange, setChartDataExchange] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
//   const currentYear = new Date().getFullYear();
//   const [chartType,setChartType] = useState("bar") //bar,line
//   const [dataType,setDataType] = useState("yearly") // yearly | monthly | weekly
//   const [selectedMonth,setSelectedMonth] = useState("January") // yearly | monthly | weekly
//   const [selectedWeek,setSelectedWeek] = useState("1") // yearly | monthly | weekly
//   const years = Array.from(
//     { length: currentYear - 2024 + 1 },
//     (_, i) => 2024 + i
//   );

//   const fetchData = (year) => {
//     setLoading(true);
//     axios
//       .get(`${Base_Uri}insights/total/sale?year=${year}&month=${selectedMonth}&week=${selectedWeek}&type=${dataType}`)
//       .then((res) => {
//         setChartData(res.data);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error fetching chart data:", err);
//         setLoading(false);
//       });
//     // axios
//     //   .get(`${Base_Uri}insights/total/return?year=${year}`)
//     //   .then((res) => {
//     //     setChartDataReturn(res.data);
//     //     setLoading(false);
//     //   })
//     //   .catch((err) => {
//     //     console.error("Error fetching chart data:", err);
//     //     setLoading(false);
//     //   });
//     // axios
//     //   .get(`${Base_Uri}insights/total/exchange?year=${year}`)
//     //   .then((res) => {
//     //     setChartDataExchange(res.data);
//     //     setLoading(false);
//     //   })
//     //   .catch((err) => {
//     //     console.error("Error fetching chart data:", err);
//     //     setLoading(false);
//     //   });
//   };

//   useEffect(() => {
//     fetchData(selectedYear);
//   }, [selectedYear,selectedMonth,selectedWeek,dataType]);

//  const options = {
//   responsive: true,
//   interaction: {
//     mode: "index",
//     intersect: false,
//   },
//   plugins: {
//     legend: {
//       display: true,
//       position: "top",
//       labels: {
//         font: { size: 12 },
//       },
//     },
//     title: {
//       display: true,
//       text: `Yearly Overview (${selectedYear})`,
//       font: { size: 16, weight: "bold" },
//     },
//     tooltip: {
//       mode: "index",
//       intersect: false,
//       callbacks: {
//         label: function (context) {
//           return `${context.dataset.label}: ${context.formattedValue}`;
//         },
//       },
//     },
//   },
//   scales: {
//     y: {
//       beginAtZero: true,
//       title: {
//         display: true,
//         text: "Amount",
//       },
//       grid: {
//         color: "rgba(200, 200, 200, 0.1)",
//       },
//     },
//     x: {
//       title: {
//         display: true,
//         text: "Months",
//       },
//       grid: {
//         color: "rgba(200, 200, 200, 0.05)",
//       },
//     },
//   },
// };
//   const optionsReturn = {
//     responsive: true,
//     plugins: {
//       legend: { position: "top" },
//       title: { display: true, text: `Yearly Returns (${selectedYear})` },
//     },
//     scales: {
//       y: { beginAtZero: true, title: { display: true, text: "Total Returns" } },
//       x: { title: { display: true, text: "Months" } },
//     },
//   };
//   const optionsExchange = {
//     responsive: true,
//     plugins: {
//       legend: { position: "top" },
//       title: { display: true, text: `Yearly Exchange (${selectedYear})` },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         title: { display: true, text: "Total Exchange" },
//       },
//       x: { title: { display: true, text: "Months" } },
//     },
//   };

//   return (
//     <div style={{ padding: "20px 30px" }}>
//       <Navbar currentPage="Dashboard" />
//       <div
//         style={{
//           display: "flex",
//           gap: "8px",
//           justifyContent: "center",
//           marginBottom: "20px",
//         }}
//       >
//         {years.map((year) => (
//           <button
//             key={year}
//             onClick={() => setSelectedYear(year)}
//             style={{
//               padding: "8px 16px",
//               borderRadius: "8px",
//               border: "1px solid #007bff",
//               backgroundColor: selectedYear === year ? "#007bff" : "white",
//               color: selectedYear === year ? "white" : "#007bff",
//               fontWeight: "bold",
//               cursor: "pointer",
//               transition: "all 0.2s",
//             }}
//           >
//             {year}
//           </button>
//         ))}
//       </div>
//       <Row gutter={[10, 10]}>
//         <Col span={24}>
//           <Card>
//             <div style={{display:"flex",alignItems:"center",gap:10}}>
//               <div>
//                 <div>Chart Type</div>
//                               <Select value={chartType} onChange={(e)=>setChartType(e)} options={[{label:"Bar Chart",value:"bar"},{label:"Line Chart",value:"line"}]} />

//               </div>
// <div>
// <div>Type</div>
//               <Select value={dataType} onChange={(e)=>setDataType(e)} options={[{label:"Yearly",value:"yearly"},{label:"Monthly",value:"monthly"},{label:"Weekly",value:"weekly"}]} />
// </div>   
// {(dataType=="monthly")&&<div>
// <div>Month</div>
//               <Select value={selectedMonth} onChange={(e)=>setSelectedMonth(e)} options={[
//       "January", "February", "March", "April", "May", "June",
//       "July", "August", "September", "October", "November", "December"
//     ]?.map((e)=>({label:e,value:e}))} />
// </div> }  
// {dataType=="weekly"&&<div>
// <div>Week Number</div>
//               <Select value={selectedWeek} onChange={(e)=>setSelectedWeek(e)} options={[
//   "1", "2", "3", "4", "5", "6", "7", "8", "9", "10",
//   "11", "12", "13", "14", "15", "16", "17", "18", "19", "20",
//   "21", "22", "23", "24", "25", "26", "27", "28", "29", "30",
//   "31", "32", "33", "34", "35", "36", "37", "38", "39", "40",
//   "41", "42", "43", "44", "45", "46", "47", "48", "49", "50",
//   "51", "52", "53"
// ]
// ?.map((e)=>({label:e,value:e}))} />
// </div> }  
//          </div>
//             {(loading||!chartData?.labels?.length) ? (
//               <p style={{ textAlign: "center" }}>Loading chart...</p>
//             ) : (
//               chartData && (chartType=="bar"?<Bar height={80} data={chartData} options={options} />:chartType=="line"?<Line height={80} data={chartData} options={options} />:<p style={{ textAlign: "center" }}>Loading chart...</p>)
//             )}
//           </Card>
//         </Col>
//         {/* <Col span={8}>
//           <Card>
//             {(loading||!chartDataReturn?.labels?.length) ? (
//               <p style={{ textAlign: "center" }}>Loading chart...</p>
//             ) : (
//               chartData && (
//                 <Bar data={chartDataReturn} options={optionsReturn} />
//               )
//             )}
//           </Card>
//         </Col>
//         <Col span={8}>
//           <Card>
//             {(loading||!chartDataExchange?.labels?.length) ? (
//               <p style={{ textAlign: "center" }}>Loading chart...</p>
//             ) : (
//               chartData && (
//                 <Bar data={chartDataExchange} options={optionsExchange} />
//               )
//             )}
//           </Card>
//         </Col> */}
//       </Row>
//     </div>
//   );
// };

// export default Dashboard;


import React, { useEffect, useState } from "react";
import { Card, Col, Row, Select, Switch } from "antd";
import Navbar from "../../Components/Navbar";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement
} from "chart.js";
import { Bar, Line } from "react-chartjs-2";
import axios from "axios";
import { Base_Uri } from "../../Constant/BaseUri";
import moment from "moment/moment";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement
);

const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const Dashboard = () => {
  const currentYear = new Date().getFullYear();

  const [chartData, setChartData] = useState({});
  const [loading, setLoading] = useState(true);

  // Current period
  const [dataType, setDataType] = useState("yearly"); // yearly, monthly, weekly
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState("January");
  const [selectedWeek, setSelectedWeek] = useState("1");

  // Compare period
  const [compareType, setCompareType] = useState("yearly");
  const [compareYear, setCompareYear] = useState(currentYear);
  const [compareMonth, setCompareMonth] = useState("December");
  const [compareWeek, setCompareWeek] = useState("1");

  const [isCompare,setIsCompare] = useState(false)

  const [totalSale,setTotalSale] = useState(0)
  const [totalReturn,setTotalReturn] = useState(0)
  const [totalExchange,setTotalExchange] = useState(0)
  const [totalCompareSale,setTotalCompareSale] = useState(0)
  const [totalCompareReturn,setTotalCompareReturn] = useState(0)
  const [totalCompareExchange,setTotalCompareExchange] = useState(0)

  const [chartStyle, setChartStyle] = useState("bar"); // bar | line
  const years = Array.from({ length: currentYear - 2024 + 1 }, (_, i) => 2024 + i);

  const fetchData = () => {
    setLoading(true);
    let params =  {
        year: selectedYear,
        type: dataType,
        month: selectedMonth,
        week: selectedWeek,
      }
if (isCompare) {
  params.compareYear=compareYear
  params.compareMonth=compareMonth
  params.compareWeek=compareWeek
}
    axios.get(`${Base_Uri}insights/total/sale`, {
      params:params
    })
    .then((res) => {
      setChartData(res.data);
      setLoading(false);
      setTotalSale((res.data?.datasets?.[0]?.data?.reduce((a,b)=>a+b)).toFixed(2))
      setTotalReturn((res.data?.datasets?.[1]?.data?.reduce((a,b)=>a+b)).toFixed(2))
      setTotalExchange((res.data?.datasets?.[2]?.data?.reduce((a,b)=>a+b)).toFixed(2))
     if (isCompare) {
       setTotalCompareSale((res.data?.datasets?.[3]?.data?.reduce((a,b)=>a+b)).toFixed(2))
      setTotalCompareReturn((res.data?.datasets?.[4]?.data?.reduce((a,b)=>a+b)).toFixed(2))
      setTotalCompareExchange((res.data?.datasets?.[5]?.data?.reduce((a,b)=>a+b)).toFixed(2))
     }
    })
    .catch((err) => {
      console.error("Error fetching chart data:", err);
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchData();
  }, [dataType, selectedYear, selectedMonth, selectedWeek, compareType, compareYear, compareMonth, compareWeek, chartStyle,isCompare]);

  const chartOptions = {
    responsive: true,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: { position: "top", labels: { font: { size: 12 } } },
      title: { display: true, text: `Sales Overview (${dataType.charAt(0).toUpperCase() + dataType.slice(1)})`, font: { size: 18, weight: "bold" } },
      tooltip: {
        mode: "index",
        intersect: false,
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.formattedValue}`
        }
      }
    },
    scales: {
      y: { beginAtZero: true, title: { display: true, text: "Amount" }, grid: { color: "rgba(200, 200, 200, 0.1)" } },
      x: { title: { display: true, text: dataType === "yearly" ? "Months" : dataType === "monthly" ? "Days" : "Days of Week" }, grid: { color: "rgba(200, 200, 200, 0.05)" } }
    }
  };

  const chartHeight = 90;

  return (
    <div style={{ padding: 24, backgroundColor: "#f5f7fa", minHeight: "100vh" }}>
      <Navbar currentPage="Dashboard" />

      {/* Year Selection */}
      <Row gutter={[12, 12]} justify="center" style={{ marginBottom: 20 }}>
        {years.map((year) => (
          <Col key={year}>
            <button
              onClick={() => setSelectedYear(year)}
              style={{
                padding: "8px 16px",
                borderRadius: 8,
                border: "none",
                backgroundColor: selectedYear === year ? "#4c6ef5" : "#e7eaf0",
                color: selectedYear === year ? "white" : "#555",
                fontWeight: 600,
                cursor: "pointer",
                transition: "all 0.2s"
              }}
            >
              {year}
            </button>
          </Col>
        ))}
      </Row>

      <Card style={{ marginBottom: 20 }}>
        <Row gutter={[16, 16]}>
          {/* Current Period */}
          <Col xs={24} md={6}>
            <div>Current Type</div>
            <Select value={dataType} onChange={setDataType} style={{ width: "100%" }}
              options={[{label:"Yearly",value:"yearly"}, {label:"Monthly",value:"monthly"}, {label:"Weekly",value:"weekly"}]} />
          </Col>
          {dataType === "monthly" && (
            <Col xs={24} md={3}>
              <div>Month</div>
              <Select value={selectedMonth} onChange={setSelectedMonth} style={{ width: "100%" }}
                options={months.map(m => ({ label: m, value: m }))} />
            </Col>
          )}
          {dataType === "weekly" && (
            <Col xs={24} md={3}>
              <div>Week</div>
              <Select value={selectedWeek} onChange={setSelectedWeek} style={{ width: "100%" }}
                options={Array.from({ length: 52 }, (_, i) => ({ label: `${i+1}`, value: `${i+1}` }))} />
            </Col>
          )}

          {/* Compare Period */}
          {isCompare&&<Col xs={24} md={6}>
            <div>Compare Type</div>
            <Select value={compareType} onChange={setCompareType} style={{ width: "100%" }}
              options={[{label:"Yearly",value:"yearly"}, {label:"Monthly",value:"monthly"}, {label:"Weekly",value:"weekly"}]} />
          </Col>}
          {(compareType === "monthly" &&isCompare)&& (
            <Col xs={24} md={3}>
              <div>Compare Month</div>
              <Select value={compareMonth} onChange={setCompareMonth} style={{ width: "100%" }}
                options={months.map(m => ({ label: m, value: m }))} />
            </Col>
          )}
          {(compareType === "weekly"&&isCompare) && (
            <Col xs={24} md={3}>
              <div>Compare Week</div>
              <Select value={compareWeek} onChange={setCompareWeek} style={{ width: "100%" }}
                options={Array.from({ length: 53 }, (_, i) => ({ label: `${i+1}`, value: `${i+1}` }))} />
            </Col>
          )}

          {/* Chart Style */}
          <Col xs={24} md={3}>
            <div>Chart Type</div>
            <Select value={chartStyle} onChange={setChartStyle} style={{ width: "100%" }}
              options={[{ label: "Bar Chart", value: "bar" }, { label: "Line Chart", value: "line" }]} />
          </Col>
          <Col xs={24} md={3}>
            <div>Compare</div>
           <Switch onChange={()=>setIsCompare(!isCompare)} />
          </Col>
        </Row>
      </Card>


<Card style={{margin:"20px 0"}}>
  <div style={{display:"flex",flexWrap:"wrap",gap:15}}>

<div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
  <div
    style={{
      background: "#fff",
      padding: "16px 22px",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
      border: "1px solid #eee",
      minWidth: "180px",
    }}
  >
    <div style={{ fontWeight: 600, color: "#444" }}>Total Sales</div>
    <div style={{ fontSize: "22px", fontWeight: 700, color: "rgba(54, 162, 235, 1)" }}>
      {totalSale}
    </div>
  </div>

  <div
    style={{
      background: "#fff",
      padding: "16px 22px",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
      border: "1px solid #eee",
      minWidth: "180px",
    }}
  >
    <div style={{ fontWeight: 600, color: "#444" }}>Total Return</div>
    <div style={{ fontSize: "22px", fontWeight: 700, color: "rgba(255, 99, 132, 1)" }}>
      {totalReturn}
    </div>
  </div>

  <div
    style={{
      background: "#fff",
      padding: "16px 22px",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
      border: "1px solid #eee",
      minWidth: "180px",
    }}
  >
    <div style={{ fontWeight: 600, color: "#444" }}>Total Exchange</div>
    <div style={{ fontSize: "22px", fontWeight: 700, color: "rgba(255, 206, 86, 1)" }}>
      {totalExchange}
    </div>
  </div>
</div>

{isCompare && (
  <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
  <div
    style={{
      background: "#fff",
      padding: "16px 22px",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
      border: "1px solid #eee",
      minWidth: "180px",
    }}
  >
    <div style={{ fontWeight: 600, color: "#444" }}>Compare Total Sales</div>
    <div style={{ fontSize: "22px", fontWeight: 700, color: "rgba(54, 162, 235, 1)" }}>
      {totalCompareSale}
    </div>
  </div>

  <div
    style={{
      background: "#fff",
      padding: "16px 22px",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
      border: "1px solid #eee",
      minWidth: "180px",
    }}
  >
    <div style={{ fontWeight: 600, color: "#444" }}>Compare Total Return</div>
    <div style={{ fontSize: "22px", fontWeight: 700, color: "rgba(255, 99, 132, 1)" }}>
      {totalCompareReturn}
    </div>
  </div>

  <div
    style={{
      background: "#fff",
      padding: "16px 22px",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
      border: "1px solid #eee",
      minWidth: "180px",
    }}
  >
    <div style={{ fontWeight: 600, color: "#444" }}>Compare Total Exchange</div>
    <div style={{ fontSize: "22px", fontWeight: 700, color: "rgba(255, 206, 86, 1)" }}>
      {totalCompareExchange}
    </div>
  </div>
</div>
)}
  </div>

</Card>
      <Card style={{ minHeight: 400 }}>
<div>
  <div>
  <div style={{ display: "flex", flexWrap: "wrap", gap: "16px", marginBottom: "12px", fontSize: "14px" }}>
  {/* Current Period */}
  <div style={{ backgroundColor: "#eef2ff", padding: "6px 12px", borderRadius: "6px", fontWeight: 600, color: "#4c6ef5" }}>
    Current:{" "}
    <span style={{ fontWeight: 500, color: "#1c1c1c" }}>
      {moment(chartData?.startDate).format("DD MMMM, YYYY")} -{" "}
      {dataType !== "weekly"
        ? moment(chartData?.endDate).subtract(1, "days").format("DD MMMM, YYYY")
        : moment(chartData?.endDate).subtract(1, "days").format("DD MMMM, YYYY")}
    </span>
  </div>

  {/* Compare Period */}
  {isCompare && chartData?.compareStart && chartData?.compareEnd && (
    <div style={{ backgroundColor: "#fff4e6", padding: "6px 12px", borderRadius: "6px", fontWeight: 600, color: "#f08c00" }}>
      Compare:{" "}
      <span style={{ fontWeight: 500, color: "#1c1c1c" }}>
        {moment(chartData?.compareStart).format("DD MMMM, YYYY")} -{" "}
        {dataType !== "weekly"
          ? moment(chartData?.compareEnd).subtract(1, "days").format("DD MMMM, YYYY")
          : moment(chartData?.compareEnd).subtract(1, "days").format("DD MMMM, YYYY")}
      </span>
    </div>
  )}
</div>
</div>
</div>


        {loading ? (
          <p style={{ textAlign: "center", marginTop: 100 }}>Loading chart...</p>
        ) : chartData?.labels?.length ? (
          chartStyle === "bar" ? <Bar height={chartHeight} data={chartData} options={chartOptions} /> :
          <Line height={chartHeight} data={chartData} options={chartOptions} />
        ) : (
          <p style={{ textAlign: "center", marginTop: 100 }}>No data available</p>
        )}
      </Card>
    </div>
  );
};

export default Dashboard;
